<div class="row">
  <div class="col-sm-12">
    <div class="card card-border">
      <div class="card-header mb-2">
        <div class="form-group row mb-2">
            <span><b>PROYECTO:</b> {{ nombreProyecto }}</span>
        </div>
      </div>

      <div class="container card-body table-responsive">
        <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped table-bordered row-border hover">
          <thead>
            <tr>
              <th>Nro.</th>
              <th>Meses</th>
              <th>Resumen</th>
              <th>Responsable</th>
              <th>Fecha Inicio</th>
              <th>Fecha Fin</th>
              <th>Fecha Actualización</th>           
              <th *ngIf="idSprRolPrincipal == idRolAnalistaMetodologico"> Gestión Fechas </th>
              <th>Acciones</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor=" let row of dataOrdenadaResumenEjecutivo;let indice = index">
              <td>{{ indice + 1 }}</td>
              <td>{{ row.nombre }}</td>
              <td>{{ row.resumen }}</td>
              <td>
                <div *ngIf="row.resumen != null">
                  {{ cosultaResponsable(row.usuario, dataUsuario)![0]?.grado }}.
                  {{ cosultaResponsable(row.usuario, dataUsuario)![0]?.nombres }}
                  {{ cosultaResponsable(row.usuario, dataUsuario)![0]?.apellidos }}
                </div>
              </td>
              <td>{{ row.fechaInicio | date : "dd-MM-yyyy" }}</td>
              <td>{{ row.fechaFin | date : "dd-MM-yyyy"  }}</td>
              <td>
                <div *ngIf="row.resumen != null">
                  {{ row.fecha | date : "dd-MM-yyyy" }}
                </div>
              </td>
            

              <td *ngIf="idSprRolPrincipal == idRolAnalistaMetodologico" class="text-center">
                <button type="button" tooltip="Editar" class="btn btn-sm btn-link waves-effect rounded-pill col px-0" title="Gestión Resumen Ejecutivo" (click)="openResumenFechas(row)">
                  <i class="fas fa-tasks fa-lg"></i>
                </button>
              </td>
              <td class="text-center">
                <div class="row" *hasDenied="{ nivel: idSprNivel, app: constant.PROYECTOS }">
                  <button *hasPermission="{ app: constant.PROYECTOS, permission: [constant.ACTUALIZAR]}" type="button" tooltip="Editar" class="btn btn-sm btn-link waves-effect rounded-pill col px-0" title="Editar este registro" (click)="update(row)">
                    <i class="fas fa-pencil-alt fa-lg"></i>
                  </button>
                  <button *hasPermission="{app: constant.PROYECTOS, permission: [constant.BORRAR]}" type="button" class="btn btn-sm btn-link waves-effect col px-0"
                    title="Eliminar este registro" (click)="delete(row.idSprResumenEjecutivo)">
                    <i class="fas fa-trash-alt fa-lg"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
<!-- ########### MODAL FECHAS  ERROR CAMPOS ################## -->
<jw-modal id="{{ modalFechasResumenEjecutivo }}">
  <div class="modal-dialog modal-lg modal-dialog-scrollable" style="padding-top: 12%" >
    <div class="modal-content">
      <div class="modal-header pb-6">
        <button type="button" class="btn-close" (click)="modal.closeId(modalFechasResumenEjecutivo)" aria-label="Close" ></button>
         </div>
         <div class="modal-body pT-4">
          <div class="card-header mb-2">
            <div class="form-group row mb-2">
              <div class="pservices text-justify">
                <span><b>Proyecto: </b>{{ nombreProyecto }}</span>
              </div>
        
              <div class="col col-md-1 text-md-center pt-2 titulo-seccion">
                <span>Mes:</span>
              </div>
        
              <div class="col col-md-3 col-md-6 text-md-center pt-2">
                <label for="mes">{{ nombreMes }}</label>
              </div>
            </div>
          </div>
        </div>
      
      <div class="card mb-1">
        <div class="modal-body px-5">
          <form action="#" [formGroup]="formFechasResumen" class="needs-validation">
            <input  type="hidden" id="idSprResumenEjecutivo" formControlName="idSprResumenEjecutivo" />
            <div class="form-group row mb-2">
              <div class="col col-md-3 text-md-center">
                <label  for="fechaInicio"  class="form-control-label text-md-right pt-1"><b>Fecha Inicio:</b></label>
              </div>

              <div class="col-12 col-md-4">
                <input  type="date"  class="form-control"  placeholder="fechaInicio"  formControlName="fechaInicio"  style="background-color: #f5f4f4;" [ngClass]="{'is-invalid': this.formFechasResumen.get('fechaInicio')?.errors && this.submitted,'is-valid': !this.formFechasResumen.get('fechaInicio')?.errors }"/>
              </div>
            </div>

            <div class="form-group row mb-2">
              <div class="col col-md-3 text-md-center">
                <label for="fechaFin" class="form-control-label text-md-right pt-1"><b>Fecha Fin:</b></label>
              </div>

              <div class="col-12 col-md-4">
                <input  type="date" class="form-control"  placeholder="fechaFin" formControlName="fechaFin" [ngClass]="{'is-invalid': this.formFechasResumen.get('fechaFin')?.errors && this.submitted,'is-valid': !this.formFechasResumen.get('fechaFin')?.errors, }"/>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button  type="button"  class="btn btn-secondary waves-effect"  (click)="modal.closeId(modalFechasResumenEjecutivo)">
            Cerrar
          </button>
          <button type="button" class="btn btn-info" (click)="onSubmit()">
            Guardar
          </button>
        </div>
      </div>
    </div>
  </div>
</jw-modal>
<!--################ MODAL CONFIRM BORRADO ############ -->
<jw-modal id="delete-etapa" [isDelete]="true"  (confirmation)="confirmDelete()"></jw-modal>

<!-- ###########  MODAL RESUMEN EJECUTIOVO ALL -->
<jw-modal id="{{ modalResumenEjecutivo }}">
  <div class="modal-dialog modal-lg modal-dialog-scrollable" style="padding-top: 6%">
    <div class="modal-content">
      <div class="modal-header pb-3">
        <h3 class="modal-title">{{ nameResumen }}</h3>
        <button type="button" class="btn-close" (click)="closeModalEtapa()" aria-label="Close"></button>
      </div>

      <div class="modal-body px-5">
        <form action="#" [formGroup]="formResumenAll" class="needs-validation">
          <input  type="hidden" id="idSprResumenEjecutivo" formControlName="idSprResumenEjecutivo"/>

          <div class="form-group row mb-2">
            <div class="col col-md-2 text-md-right">
              <label for="mes" class="col-form-label text-md-right"><b>Mes:</b></label
              >
            </div>
            <div class="col-12 col-md-10">
              <input  class="form-control" style="background-color: #f5f4f4" autocomplete="off" readonly="readonly" value="{{ nombreMes }}" />
            </div>
          </div>

          <div class="form-group row mb-2">
            <div class="col col-md-2 text-md-right">
              <label for="resumen" class="col-form-label text-md-right"><b>Resumen Ejecutivo:</b>
              </label>
            </div>
            <div class="col-12 col-md-10">
              <textarea type="text" class="form-control" maxlength="3000" rows="15" cols="50" id="resumen" formControlName="resumen" [ngClass]="{ 'is-invalid': this.formResumenAll.get('resumen')?.errors && this.formSubmitted, 'is-valid': this.formResumenAll.value.resumen}">
              </textarea>
            </div>
          </div>

          <div class="form-group row mb-2">
            <div class="col col-md-2 text-xl-right">
              <label for="estado" class="form-control-label text-md-right pt-1"><b>Estado:</b></label>
            </div>
            <div class="col-12 col-md-10">
              <select id="estado" class="form-select" formControlName="estado" required="true" [ngClass]="{'is-invalid': this.formResumenAll.get('estado')?.errors && this.formSubmitted,'is-valid': !this.formResumenAll.get('estado')?.errors,}">
                <option [value]="item.value" *ngFor="let item of selectItems">
                  {{ item.label }}
                </option>
              </select>
              <div class="col text-danger">
                <span class="font-italic" *ngIf="this.formResumenAll.get('estado')?.errors?.['required'] && this.formSubmitted">Campo requerido</span>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button  type="button"  class="btn btn-secondary waves-effect"  (click)="closeModalEtapa()">
          Cerrar
        </button>
        <button *hasPermission="{ app: constant.PROYECTOS, permission: [constant.CREAR, constant.ACTUALIZAR]}" type="button"  class="btn btn-info"  (click)="onSubmitResumenEjecutivo()">
          Guardar
        </button>
      </div>
    </div>
  </div>
</jw-modal>
